import { Link } from 'react-router-dom';
import Form from '../../components/reusableElementsComponents/Form';
import mazharLogo from "../../assets/images/logos/apex_analytics_green_logo.svg";

import person from '../../assets/images/icons/person.svg';
import letter from '../../assets/images/icons/letter.svg';

import MobileAuthHeader from '../../components/layoutComponents/authComponents/MobileAuthHeader';
import DesktopAuthDecoration from '../../components/layoutComponents/authComponents/DesktopAuthDecoration';
import AuthPageChrome from '../../components/layoutComponents/authComponents/AuthPageChrome';

// import { useSelector } from 'react-redux';
import { t } from '../../content';
import { useLocale } from '../../locale';


function RegistrationStage3() {
    const { withLocale } = useLocale();
    const template = {
        fields: [
            {
                title: t('common.fields.fullName'),
                type: 'text',
                name: 'fullName',
                placeholder: t('common.placeholders.startTyping'),
                icon: person
            },
            {
                title: t('common.fields.email'),
                type: 'text',
                name: 'email',
                placeholder: t('common.placeholders.startTyping'),
                icon: letter
            }
        ]
    };

    return (
        <div className="row auth-page-wrapper p-0 m-0">
            <AuthPageChrome logoSrc={mazharLogo} />
            <MobileAuthHeader subTitle={t('auth.register.stage3.subtitleMobile')}/>
            <div className="col-12 col-lg-6 login-form">
                <div className="section d-none d-lg-block">
                    <h3 className="title semi-bold">{t('auth.register.stage3.titleDesktop')}</h3>
                    <p className="grey s">{t('auth.register.stage3.subtitleDesktop')}</p>
                </div>
                <div className="section">
                    <Form template={template} />
                    <div className="authButtons">
                        <Link className="mazhrBtn light-green" to={withLocale("/login")}>{t('common.actions.invite')}</Link>
                        <Link className="mazhrBtn default-green white" to="/dashboard">{t('common.actions.finish')}</Link>
                    </div>
                </div>
            </div>
            <DesktopAuthDecoration />
        </div>
    );
}

export default RegistrationStage3;
